// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:51:55

export default {
  "id": "funny-balls-2048",
  "slug": "funny-balls-2048",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1a044718dad340938f955338c6db2552-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1a044718dad340938f955338c6db2552/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Funny Balls 2048",
      "description": "Funny Balls 2048 combines the 2048 genre with physics. Drop bouncing balls so that to collapse them with identical ones and get a ball of 2 times more value. The game has boosters that will make the game more exciting, as well as different ball skins.",
      "instructions": "Drop the balls and collect large denominations, there are hints in the game. The balls collapse according to the 2048 principle, i.e. two balls with the same face value will give a ball with a 2-fold larger face value. The game records a record, which is also displayed on the leaderboard, where you can compare yourself with other players.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "ball",
        "physics"
      ]
    },
    "zh-CN": {
      "title": "搞笑球2048",
      "description": "搞笑球2048结合了2048游戏类型和物理元素。下落弹跳球，使它们与相同的球相撞并得到价值翻倍的球。游戏包含增强器，可以让游戏更加刺激，以及不同的球皮肤。",
      "instructions": "扔掉球并收集大面额，游戏中包含提示。球会根据2048规则坍塌，即两个面值相同的球会合成一个面值翻倍的新球。游戏记录最高分，并在排行榜上显示，你可以与其他玩家进行比较。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "2048",
        "球",
        "物理"
      ]
    },
    "zh-TW": {
      "title": "有趣球2048",
      "description": "Funny Balls 2048結合了2048遊戲類型和物理學。將彈跳球落下，使其與相同的球合併，獲得價值增加2倍的球。遊戲有加強器，可以讓遊戲更加刺激，還有各種球皮膚。",
      "instructions": "丟下球並收集大面額，遊戲中有提示。球會根據2048原則塌陷，即兩個面值相同的球會產生一個面值為兩倍的球。遊戲記錄紀錄，也會顯示在排行榜上，您可以與其他玩家比較。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "2048",
        "球體",
        "物理學"
      ]
    },
    "zh-HK": {
      "title": "funny balls 2048",
      "description": "Funny Balls 2048 結合了 2048 風格與物理元素。落下彈跳球，將相同數值的球擠壓合併，獲得兩倍價值的球。遊戲具有提升器，讓遊戲更加刺激，並提供不同球皮。",
      "instructions": "放下球並收集大面額，遊戲中有提示。球會根據2048原則倒塌，即兩個面值相同的球會合併成面值加倍的新球。遊戲記錄紀錄，並在排行榜上顯示，您可以與其他玩家比較。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "2048",
        "波珠",
        "物理學"
      ]
    },
    "ja": {
      "title": "面白いボール2048",
      "description": "Funny Balls 2048は、2048のジャンルと物理を融合させたゲームです。重力的に跳ねるボールを落下させ、同じボールと合体させて2倍の価値を持つボールを獲得します。ゲームには、よりエキサイティングにするブースターと、さまざまなボールのスキンがあります。",
      "instructions": "ボールを落とし、大きな金額を集めろ。ゲームにはヒントがある。ボールは2048の原則に従って崩れ、同じ額面のボールが2倍の額面のボールになる。ゲームは記録を記録し、リーダーボードに表示され、他のプレイヤーと比較できる。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "2048",
        "ボール",
        "物理"
      ]
    },
    "ko": {
      "title": "有趣的球 2048",
      "description": "Funny Balls 2048은 2048 장르와 물리학을 결합한 게임입니다. 동일한 볼을 충돌시키기 위해 떨어지는 볼을 내려놓고, 2배 더 큰 볼을 얻습니다. 게임에는 게임을 더 흥미롭게 만들어 줄 보스터와 다양한 볼 스킨이 있습니다.",
      "instructions": "공을 내려놓고 큰 숫자를 모으세요. 게임에 힌트가 있습니다. 공들은 2048 원칙에 따라 붕괴합니다. 즉, 같은数值의 두 공은 두 배 큰数值의 공으로 합쳐집니다. 게임은 기록을 기록하고, 랭킹보드에도 표시되어 있어 다른 플레이어들과 자신을 비교할 수 있습니다.",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "2048",
        "공",
        "물리학"
      ]
    },
    "fr": {
      "title": "Boules drôles 2048",
      "description": "Funny Balls 2048 combine le genre 2048 avec la physique. Faites tomber des balles rebondissantes pour les faire fusionner avec des balles identiques et obtenir une balle deux fois plus-value. Le jeu possède des boosters qui rendront le jeu plus excitant, ainsi que différentes peaux de balle.",
      "instructions": "Laissez tomber les billes et collectez les grandes valeurs, des indices sont présents dans le jeu. Les billes s'effondrent selon le principe de 2048, c'est-à-dire que deux billes de même valeur donneront une bille de valeur deux fois plus grande. Le jeu enregistre un record, qui est également affiché sur le classement, où vous pouvez vous comparer aux autres joueurs.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "balle",
        "physique"
      ]
    }
  }
};
